// extracted by mini-css-extract-plugin
export default {"Container":"textWithImage_Container__BZrVy","TextContent":"textWithImage_TextContent__riNSY","title":"textWithImage_title__A6lOZ","description":"textWithImage_description__t8QzQ"};